export enum ErrorStateType {
  ValidationFailure = 'ValidationFailure',
  MissingParameters = 'MissingParameters',
  MissingAccountAssociation = 'MissingAccountAssociation',
  InvalidTOS = 'InvalidTOS',
  Unauthorized = 'Unauthorized',
  UserAlreadyExists = 'UserAlreadyExists',
  InvalidEmailAddress = 'InvalidEmailAddress',
  InvalidUsernamePassword = 'InvalidUsernamePassword',
  TokenTimedOut = 'TokenTimedOut',
  InvalidPasswordResetToken = 'InvalidPasswordResetToken',
  LockedAccount = 'LockedAccount',
}

export enum FolderValidationErrorType {
  MissingExperimentList = 'MissingExperimentList',
  MultipleExperimentList = 'MultipleExperimentList',
  MissingRunParameter = 'MissingRunParameter',
}

export enum UploadValidationErrorType {
  MissingFile = 'MissingFile',
  InvalidFileName = 'InvalidFileName',
  MissingContent = 'MissingContent',
  InvalidFileFormat = 'InvalidFileFormat',
  MissingRequiredHeaders = 'MissingRequiredHeaders',
  InvalidTagPlate = 'InvalidTagPlate',
  MissingRequiredPlateInformation = 'MissingRequiredPlateInformation',
  MismatchPlateInformationAcrossSamples = 'MismatchPlateInformationAcrossSamples',
  InvalidSampleDateFormat = 'InvalidSampleDateFormat',
  InvalidSampleInformation = 'InvalidSampleInformation',
  InvalidSampleName = 'InvalidSampleName',
  InvalidSampleNameConsecutiveUnderscore = 'InvalidSampleNameConsecutiveUnderscore',
  MismatchSampleInformationAcrossWells = 'MismatchSampleInformationAcrossWells',
  InvalidTestType = 'InvalidTestType',
  InvalidExternalSubjectId = 'InvalidExternalSubjectId',
  MissingRequiredSampleInformation = 'MissingRequiredSampleInformation',
  SampleMissingWells = 'SampleMissingWells',
  InvalidWell = 'InvalidWell',
  WellsRepeatedAcrossSamples = 'WellsRepeatedAcrossSamples',
  InvalidSourceType = 'InvalidSourceType',
  InvalidMaterial = 'InvalidMaterial',
  InvalidPrimerLot = 'InvalidPrimerLot',
  ExtraHeaders = 'ExtraHeaders',
  ExtraColumns = 'ExtraColumns',
}
